import * as React from "react"
import { useState } from "react"

interface RedirectContextProps {
  redirectUrl: string | null
  setRedirectUrl: React.Dispatch<string> | null
}

export const RedirectContext = React.createContext<RedirectContextProps>({
  redirectUrl: null,
  setRedirectUrl: null,
})

export const RedirectProvider = ({ children }) => {
  const [redirectUrl, setRedirectUrl] = useState<string>()

  return (
    <RedirectContext.Provider value={{ redirectUrl, setRedirectUrl }}>
      {children}
    </RedirectContext.Provider>
  )
}
